{
	"roundness": 0,
	"colors": {
		"dark": {
			"primary": "rgb(198, 168, 255)",
			"onPrimary": "rgb(50, 0, 93)",
			"primaryContainer": "rgb(74, 10, 116)",
			"onPrimaryContainer": "rgb(243, 235, 255)",
			"secondary": "rgb(105, 255, 129)",
			"onSecondary": "rgb(0, 57, 10)",
			"secondaryContainer": "rgb(0, 79, 19)",
			"onSecondaryContainer": "rgb(151, 255, 168)",
			"tertiary": "rgb(143, 226, 255)",
			"onTertiary": "rgb(0, 53, 67)",
			"tertiaryContainer": "rgb(0, 77, 96)",
			"onTertiaryContainer": "rgb(212, 247, 255)",
			"error": "rgb(255, 180, 171)",
			"onError": "rgb(105, 0, 5)",
			"errorContainer": "rgb(147, 0, 10)",
			"onErrorContainer": "rgb(255, 180, 171)",
			"background": "rgb(25, 24, 28)",
			"onBackground": "rgb(249, 248, 239)",
			"surface": "rgb(25, 24, 28)",
			"onSurface": "rgb(249, 248, 239)",
			"surfaceVariant": "rgb(48, 46, 52)",
			"onSurfaceVariant": "rgb(206, 195, 205)",
			"outline": "rgb(151, 142, 151)",
			"outlineVariant": "rgb(63, 73, 70)",
			"shadow": "rgb(0, 0, 0)",
			"scrim": "rgb(0, 0, 0)",
			"inverseSurface": "rgb(249, 248, 239)",
			"inverseOnSurface": "rgb(51, 47, 51)",
			"inversePrimary": "rgb(58, 19, 89)",
			"elevation": {
				"level0": "transparent",
				"level1": "rgb(40, 35, 41)",
				"level2": "rgb(46, 39, 48)",
				"level3": "rgb(52, 44, 55)",
				"level4": "rgb(55, 45, 57)",
				"level5": "rgb(59, 48, 62)"
			},
			"surfaceDisabled": "rgba(249, 248, 239, 0.12)",
			"onSurfaceDisabled": "rgba(249, 248, 239, 0.38)",
			"backdrop": "rgba(53, 46, 54, 0.4)"
		},
		"light": {
			"primary": "rgb(58, 19, 89)",
			"onPrimary": "rgb(255, 255, 255)",
			"primaryContainer": "rgb(243, 235, 255)",
			"onPrimaryContainer": "rgb(29, 0, 56)",
			"secondary": "rgb(35, 210, 63)",
			"onSecondary": "rgb(255, 255, 255)",
			"secondaryContainer": "rgb(204, 255, 211)",
			"onSecondaryContainer": "rgb(0, 39, 6)",
			"tertiary": "rgb(68, 210, 255)",
			"onTertiary": "rgb(0, 0, 0)",
			"tertiaryContainer": "rgb(212, 247, 255)",
			"onTertiaryContainer": "rgb(0, 31, 38)",
			"error": "rgb(186, 26, 26)",
			"onError": "rgb(255, 255, 255)",
			"errorContainer": "rgb(255, 218, 214)",
			"onErrorContainer": "rgb(65, 0, 2)",
			"background": "rgb(249, 248, 239)",
			"onBackground": "rgb(25, 28, 26)",
			"surface": "rgb(255, 255, 255)",
			"onSurface": "rgb(25, 28, 26)",
			"surfaceVariant": "rgb(243, 241, 230)",
			"onSurfaceVariant": "rgb(63, 73, 70)",
			"outline": "rgb(116, 114, 108)",
			"outlineVariant": "rgb(228, 225, 216)",
			"shadow": "rgb(0, 0, 0)",
			"scrim": "rgb(0, 0, 0)",
			"inverseSurface": "rgb(51, 47, 51)",
			"inverseOnSurface": "rgb(246, 239, 243)",
			"inversePrimary": "rgb(198, 168, 255)",
			"elevation": {
				"level0": "transparent",
				"level1": "rgb(243, 241, 230)",
				"level2": "rgb(238, 235, 222)",
				"level3": "rgb(233, 229, 214)",
				"level4": "rgb(231, 226, 210)",
				"level5": "rgb(226, 220, 202)"
			},
			"surfaceDisabled": "rgba(30, 27, 30, 0.12)",
			"onSurfaceDisabled": "rgba(30, 27, 30, 0.38)",
			"backdrop": "rgba(53, 46, 54, 0.4)"
		}
	},
	"brandPalette": {
		"primary": {
			"purple": "rgb(58, 19, 89)",
			"ecru": "rgb(249, 248, 239)",
			"white": "rgb(255, 255, 255)"
		},
		"secondary": {
			"green": "rgb(35, 210, 63)",
			"blue": "rgb(68, 210, 255)",
			"red": "rgb(254, 96, 47)",
			"pink": "rgb(255, 143, 224)",
			"yellow": "rgb(255, 214, 0)"
		},
		"container": {
			"purple": "rgb(58, 19, 89)",
			"green": "rgb(35, 210, 63)",
			"blue": "rgb(68, 210, 255)",
			"red": "rgb(254, 96, 47)",
			"pink": "rgb(255, 143, 224)",
			"yellow": "rgb(255, 214, 0)",
			"neutral": "rgb(249, 248, 239)",
			"surface": "rgb(255, 255, 255)"
		}
	},
	"typography": {
		"fontFamilies": {
			"display": "Raw Sans",
			"editorial": "Rhetorik Serif",
			"body": "ABC Diatype",
			"ui": "ABC Diatype"
		},
		"roles": {
			"displayLarge": {
				"fontFamily": "Raw Sans",
				"fontWeight": "700",
				"fontSize": 40,
				"lineHeight": 36,
				"letterSpacing": 1.2,
				"textTransform": "uppercase"
			},
			"displayMedium": {
				"fontFamily": "Raw Sans",
				"fontWeight": "700",
				"fontSize": 32,
				"lineHeight": 28.8,
				"letterSpacing": 0.96,
				"textTransform": "uppercase"
			},
			"headlineLarge": {
				"fontFamily": "Rhetorik Serif",
				"fontWeight": "300",
				"fontSize": 34,
				"lineHeight": 30.6,
				"letterSpacing": 1.02
			},
			"headlineMedium": {
				"fontFamily": "ABC Diatype",
				"fontWeight": "700",
				"fontSize": 28,
				"lineHeight": 40.6,
				"letterSpacing": -0.28
			},
			"titleLarge": {
				"fontFamily": "ABC Diatype",
				"fontWeight": "700",
				"fontSize": 22,
				"lineHeight": 31.9,
				"letterSpacing": -0.22
			},
			"titleMedium": {
				"fontFamily": "ABC Diatype",
				"fontWeight": "700",
				"fontSize": 18,
				"lineHeight": 26.1,
				"letterSpacing": -0.18
			},
			"bodyLarge": {
				"fontFamily": "ABC Diatype",
				"fontWeight": "400",
				"fontSize": 16,
				"lineHeight": 23.2,
				"letterSpacing": -0.16
			},
			"bodyMedium": {
				"fontFamily": "ABC Diatype",
				"fontWeight": "400",
				"fontSize": 14,
				"lineHeight": 20.3,
				"letterSpacing": -0.14
			},
			"labelLarge": {
				"fontFamily": "ABC Diatype",
				"fontWeight": "700",
				"fontSize": 14,
				"lineHeight": 18,
				"letterSpacing": -0.14
			},
			"labelMedium": {
				"fontFamily": "ABC Diatype",
				"fontWeight": "700",
				"fontSize": 12,
				"lineHeight": 16,
				"letterSpacing": -0.12
			}
		}
	}
}
